// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/notasD2l/notasD2l.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_NOTAS_D2L = [
  {
    id: 'id',
    label: 'ID',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Alumno',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'usuario',
    label: 'Usuario',
    width: 140,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Alumno',
  },
  { id: 'nombre', label: 'Nombre', width: 140, sortable: true, filter: 'text', group: 'Alumno' },
  {
    id: 'apellido',
    label: 'Apellidos',
    width: 160,
    sortable: true,
    filter: 'text',
    group: 'Alumno',
  },
  {
    id: 'codigo_oferta',
    label: 'Código oferta',
    width: 150,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Oferta',
  },
  {
    id: 'nombre_oferta',
    label: 'Oferta',
    width: 220,
    sortable: true,
    filter: 'text',
    group: 'Oferta',
  },
  {
    id: 'categoria_elemento',
    label: 'Categoría',
    width: 160,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Oferta',
  },
  {
    id: 'nombre_elemento',
    label: 'Elemento',
    width: 180,
    sortable: true,
    filter: 'text',
    group: 'Oferta',
  },
  {
    id: 'numerador_puntos',
    label: 'Puntos',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Calificación',
  },
  {
    id: 'denominador_puntos',
    label: 'Puntos máximos',
    width: 120,
    sortable: true,
    filter: 'text',
    align: 'right',
    defaultVisible: false,
    group: 'Calificación',
  },
  {
    id: 'ponderacion',
    label: 'Ponderación',
    width: 110,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Calificación',
  },
  {
    id: 'valor_calificacion',
    label: 'Calificación',
    width: 120,
    sortable: true,
    filter: 'text',
    group: 'Calificación',
  },
  {
    id: 'evaluador',
    label: 'Evaluador',
    width: 160,
    sortable: true,
    filter: 'text',
    group: 'Calificación',
  },
  {
    id: 'usuario_evaluador',
    label: 'Usuario evaluador',
    width: 140,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Calificación',
  },
  {
    id: 'ultima_modificacion',
    label: 'Últ. modificación',
    width: 150,
    sortable: true,
    filter: 'date',
    group: 'Calificación',
    hora: true,
  },
  {
    id: 'comentarios',
    label: 'Comentario',
    width: 120,
    sortable: true,
    filter: 'text',
    group: 'Calificación',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_NOTAS_D2L = 'notas-d2l';
